import React, { useEffect, useState } from 'react';
import axios from 'axios';
import SEO from '../../components/SEO';
import '../../styles/company-services.css';

export default function CompanyServices() {
  const [company, setCompany] = useState(null);
  const { id } = require('react-router-dom').useParams();

  useEffect(() => {
    let mounted = true;
    async function fetchCompany() {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL || ''}/companies/${id}`);
        if (mounted) setCompany(res.data);
      } catch (err) {
        console.error(err);
      }
    }
    fetchCompany();
    return () => { mounted = false; };
  }, [id]);

  if (!company) return <div className="company-loading">Loading...</div>;

  return (
    <div className="company-services">
      <SEO
        title={`${company.name} - Services`}
        description={`Services offered by ${company.name} on Dofcan Oilserve.`}
        path={`/company/${id}/services`}
      />

      <h1>Services</h1>
      <ul className="services-list">
        {company.services && company.services.length ? (
          company.services.map((s, i) => <li key={i}>✓ {s}</li>)
        ) : (
          <li className="services-empty">No services listed.</li>
        )}
      </ul>
    </div>
  );
}
